import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'ls-counters',
  styleUrl: 'ls-counters.css',
  shadow: true,
})
export class LsCounters {

  render() {
    return (
      <Host>
        <fieldset>
          <legend>ls-counters</legend>
        </fieldset>
        <slot></slot>
      </Host>
    );
  }

}
